/** Edit one platform's Schedule A top to bottom (BIN / Risk first); writes back into the draft's platform column. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';

export function PlatformScheduleEditor({ d, setD, versionId }) {
  const [platform, setPlatform] = useState(d.platforms[0]);
  const [lines, setLines] = useState([]);
  useEffect(() => {
    api.request(`/admin/schedule-a/platform-lines?platform=${encodeURIComponent(platform)}&source=draft`)
      .then((r) => setLines(r.lines)).catch((e) => toast.error(e.message || 'Could not load the platform lines'));
  }, [platform, versionId]);
  const val = ({ ref }) => d.sections[ref.section]?.rows[ref.row]?.values[ref.col] ?? '';
  const set = ({ ref }, v) => setD({ ...d, sections: d.sections.map((s, si) => (si !== ref.section ? s : {
    ...s, rows: s.rows.map((r, ri) => (ri !== ref.row ? r : { ...r, values: r.values.map((x, ci) => (ci === ref.col ? v : x)) })) })) });
  let lastCat = null;
  return (
    <div className="space-y-3" data-testid="platform-editor">
      <div className="flex flex-wrap gap-2">{d.platforms.map((p) => (
        <button key={p} type="button" onClick={() => setPlatform(p)} className={`rounded-full border px-4 py-1.5 text-sm ${p === platform ? 'bg-primary text-primary-foreground' : 'bg-card hover:bg-muted'}`} data-testid={`platform-chip-${p.replace(/\W/g, '')}`}>{p}</button>))}</div>
      <p className="text-xs text-muted-foreground">{lines.length} lines for {platform}, in Schedule A order. Edit a value and press Save draft below.</p>
      <div className="overflow-x-auto rounded-lg border"><table className="w-full text-sm"><tbody>
        {lines.map((l, i) => {
          const head = l.category !== lastCat ? (lastCat = l.category) : null;
          return (
            <React.Fragment key={`${l.fee_code}-${i}`}>
              {head && <tr className="bg-muted/50"><td colSpan={2} className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{head}</td></tr>}
              <tr className="border-b last:border-0" data-testid={`platform-line-${i}`}>
                <td className="px-3 py-1.5">{l.label}{l.feeds_payouts && <span className="ml-1 rounded bg-sky-100 px-1 text-[10px] text-sky-800">payouts</span>}</td>
                <td className="w-32 px-2 py-1 sm:w-56 sm:px-3"><input className="h-8 w-full rounded-md border bg-background px-2 text-xs" value={val(l)} onChange={(e) => set(l, e.target.value)} data-testid={`platform-line-input-${i}`} /></td>
              </tr>
            </React.Fragment>
          );
        })}
      </tbody></table></div>
    </div>
  );
}
